import { changedShots, type ChunkEditDraft } from "./chunkEdit";
import type { ShotEditForm } from "./shotEditForm";

/**
 * 这次「改文案」改的是**哪一类**东西 —— 决定面板给哪个主按钮、说哪句话。
 *
 * ═══ 三栏并不等价 ═══════════════════════════════════════════════════════════
 * 老板问「改文案那里现在能改的是传给 seedance 的原文么」。分栏答案不同:
 *   · `panelPrompt`(画面) / `panelMotion`(运动)
 *       → 进 ai 的 `compile_chunk_prompt`,**就是发给 seedance 的那段原文**
 *         (真实形状:「8秒,风格总纲。0-2秒:远景,升镜。<画面>。…」)
 *       → 改了**必须重渲**才生效,按段计费
 *   · `voiceover`(口播)
 *       → 只进 TTS 与烧字幕,**根本不在那段 prompt 里**(段 prompt 里反而写着
 *         「全程人物闭口不出声」)
 *       → 改了下次「合成成片」就生效,不重渲、不花钱
 *
 * 面板上这三栏此前视觉完全平级,口播那栏 label 虽写着「不必重渲画面」却没人会注意 ——
 * 于是只改了个错别字的人照样去点满宽紫色的「保存并重渲本段」,白花一次段渲染的钱。
 * 主按钮因此不该写死,由本函数按**实际改动**决定。
 */
export type EditImpact =
  /** 什么都没改。 */
  | "none"
  /** 只动了口播:存一下就行,不用重渲。 */
  | "voice"
  /** 动了画面/运动:那是发给 seedance 的原文,要重渲才生效。 */
  | "visual";

/** 影响画面的字段 —— 与 ai 侧 compile_chunk_prompt 的取值口径对齐。 */
const VISUAL_KEYS: (keyof ShotEditForm)[] = ["panelPrompt", "panelMotion"];

export function editImpact(draft: ChunkEditDraft): EditImpact {
  const changed = changedShots(draft);
  if (changed.length === 0) return "none";
  const touchedVisual = changed.some((s) =>
    VISUAL_KEYS.some((k) => s.form[k] !== s.origin[k])
  );
  return touchedVisual ? "visual" : "voice";
}
